import { uniq } from "lodash"
import {
  CategoriesTree,
  CategoriesTreeItem,
} from "../components/controller/state/categories"
import { SearchState } from "../types"

export const addValue = <T>(values: T[], value: T) => uniq([...values, value])

export const removeValue = <T>(values: T[], value: T, enabledValues: T[]) => {
  if (enabledValues.length === 1 && value === enabledValues[0]) {
    return []
  }
  return values.filter((x) => x !== value)
}

const expandTreeOptions = (
  options: CategoriesTreeItem[]
): CategoriesTreeItem[] => {
  const values = []
  for (const option of options) {
    values.push(option)
    if (option.children) {
      values.push(...expandTreeOptions(option.children))
    }
  }
  return values
}

const getCurrentCodes = (searchParams: SearchState) =>
  searchParams.categoryCodes ?? []

export const unselectProductCategory = (
  searchParams: SearchState,
  option: CategoriesTreeItem,
  tree: CategoriesTree
) => {
  const disabledCodes = expandTreeOptions(tree.root)
    .filter((x) => !x.enabled)
    .map((x) => x.code)
  return getCurrentCodes(searchParams).filter(
    (x) => !option.codes.includes(x) && !disabledCodes.includes(x)
  )
}

export const selectProductCategory = (
  searchParams: SearchState,
  option: CategoriesTreeItem
) => {
  return uniq([...getCurrentCodes(searchParams), ...option.codes])
}

export const isCategoryActive = (option: CategoriesTreeItem) => {
  return option.checked || option.allEnabledChildrenChecked
}
